import {
	areRovoControlsSuppressed,
	type RovoControlsSuppressedParams,
} from './areRovoControlsSuppressed';

export type WebSearchEnabledForSubmitParams = RovoControlsSuppressedParams & {
	webSearchConfigEnabled: boolean;
	webSearchEnabled: boolean;
};

/**
 * Returns the `webSearchEnabled` value to be forwarded to `onSubmit`.
 *
 * False when Rovo controls are suppressed (see `areRovoControlsSuppressed`): a
 * mentioned specialist agent owns its sources, or a specialist agent owns the
 * turn. Also false when web search is disabled in product config.
 */
export const getWebSearchEnabledForSubmit = ({
	isAgentMentionActive,
	isSpecialistPromptInput,
	webSearchConfigEnabled,
	webSearchEnabled,
}: WebSearchEnabledForSubmitParams): boolean =>
	!areRovoControlsSuppressed({ isAgentMentionActive, isSpecialistPromptInput }) &&
	webSearchConfigEnabled &&
	webSearchEnabled;
